import * as yup from "yup";
import { diff } from "deep-object-diff";
import dayjs from "dayjs";

export const filterNulls = (obj) => {
  return JSON.parse(
    JSON.stringify(obj, (key, value) => (value === null ? "" : value))
  );
};

export const getDirtyValuesCount = (initialValues, currentValues) => {
  const res = diff(initialValues, currentValues);
  const keys = Object.keys(res);
  if (keys.includes("dateTimeFrom") && keys.includes("dateTimeTo")) {
    return keys.length - 1;
  }
  return keys.length;
};

export const initialFilters = {
  dateTimeFrom: dayjs().startOf("year").format("YYYY-MM-DD HH:mm"),
  dateTimeTo: dayjs().endOf("day").format("YYYY-MM-DD HH:mm"),
  currencies: [],
  countries: [],
  amountFrom: null,
  amountTo: null,
  standing: "ALL",
  type: null,
  direction: null,
  sessionNumber: "",
  sequenceNumberFrom: null,
  sequenceNumberTo: null,
  source: "ALL",
  f20ReferenceNumber: "",
  f21ReferenceNumber: "",
  f108Mur: "",
  uetr: "",
  clearanceCode: "",
  fieldkey: "",
  fieldValue: "",
  gpiStatuses: [],
  agentBIC: "",
  agentType: "ALL",
  customerClientId: "",
  customerAccountNumber: "",
  customerIban: "",
  customerBban: "",
  f50AOrderingCustomer: "",
  f59ABeneficiaryCustomer: "",
  institutionSender: "",
  institutionReceiver: "",
  f56AIntermediaryBank: "",
  f53ASenderCorrespondent: "",
  f54AReceiverCorrespondent: "",
  f52AOrderingInstitution: "",
  f57AAccountInstitution: "",
};

export const allFiltersSchema = yup.object().shape({
  dateTimeFrom: yup.date().required("Date range is required"),
  dateTimeTo: yup.date().required("Date range is required"),
  countries: yup.array("Invalid countries").of(yup.string()),
  currencies: yup.array("Invalid currencies").of(yup.string()),
  amountFrom: yup.number("Invalid amount").nullable(),
  amountTo: yup.number("Invalid amount").nullable(),
  amountFromTo: yup.bool().when(["amountFrom", "amountTo"], {
    is: (amountFrom, amountTo) =>
      (!amountFrom && amountTo) || (amountFrom && !amountTo),
    then: yup.bool().required("Both range values are required"),
    otherwise: yup.bool().notRequired(),
  }),
  standing: yup.string("Invalid message standing/status").nullable(),
  type: yup.string("Invalid message type number").nullable(),
  direction: yup.string("Invalid message way").nullable(),
  sessionNumber: yup.string("Invalid session number").nullable(),
  sequenceNumberFrom: yup.number("Invalid sequence number range").nullable(),
  sequenceNumberTo: yup.number("Invalid sequence number range").nullable(),
  sequenceFromTo: yup.bool().when(["sequenceNumberFrom", "sequenceNumberTo"], {
    is: (sequenceNumberFrom, sequenceNumberTo) =>
      (!sequenceNumberFrom && sequenceNumberTo) ||
      (sequenceNumberFrom && !sequenceNumberTo),
    then: yup.bool().required("Both range values are required"),
    otherwise: yup.bool().notRequired(),
  }),
  source: yup.string("Invalid message source").nullable(),
  f20ReferenceNumber: yup.string("Invalid reference number").nullable(),
  f21ReferenceNumber: yup.string("Invalid reference number").nullable(),
  f108Mur: yup.string("Invalid MUR").nullable(),
  clearanceCode: yup.string("Invalid clearance code").nullable(),
  fieldkey: yup.string("Invalid field number").nullable(),
  fieldValue: yup.string("Invalid text message").nullable(),
  uetr: yup.string("Invalid UETR").nullable(),
  gpiStatuses: yup.array("Invalid GPI status").of(yup.string()),
  agentBic: yup.string("Invalid agent BIC").nullable(),
  agentType: yup.string("Invalid agent type").nullable(),
  customerClientId: yup.string("Invalid customer client ID").nullable(),
  customerAccountNumber: yup
    .string("Invalid customer account number")
    .nullable(),
  customerIban: yup.string("Invalid customer IBAN").nullable(),
  customerBban: yup.string("Invalid customer BBAN").nullable(),
  f50AOrderingCustomer: yup.string("Invalid ordering customer").nullable(),
  f59ABeneficiaryCustomer: yup
    .string("Invalid beneficiary customer")
    .nullable(),
  institutionSender: yup.string("Invalid institution sender").nullable(),
  institutionReceiver: yup.string("Invalid institution receiver").nullable(),
  f56AIntermediaryBank: yup.string("Invalid intermediary bank").nullable(),
  f53ASenderCorrespondent: yup
    .string("Invalid sender correspondent")
    .nullable(),
  f54AReceiverCorrespondent: yup
    .string("Invalid receiver correspondent")
    .nullable(),
  f52AOrderingInstitution: yup
    .string("Invalid ordering institution")
    .nullable(),
  f57AAccountInstitution: yup.string("Invalid account institution").nullable(),
});

export const getInitialFilters = (view) => {
  const filters = { ...initialFilters };
  if (view === "day") {
    const today = new Date();
    const day = today.getDate();
    const year = today.getFullYear();
    const month = today.getMonth() + 1;

    filters.dateTimeFrom = `${year}-${month >= 10 ? month : "0" + month}-${
      day >= 10 ? day : "0" + day
    } 00:00`;
    filters.dateTimeTo = `${year}-${month >= 10 ? month : "0" + month}-${
      day >= 10 ? day : "0" + day
    } 23:59`;
  }

  return filters;
};
